import "./ErrorMessage.sass";

/**
 * Componente ErrorMessage - Muestra un mensaje de error con animación
 * 
 * Características:
 * - Se muestra solo cuando hay un mensaje de error
 * - Animación suave de entrada (slideDown)
 * - Estilos visuales claros para indicar error
 * - Responsive y accesible
 * 
 * @component
 * @param {Object} props - Propiedades del componente
 * @param {string} props.message - Mensaje de error a mostrar
 * @returns {JSX.Element|null} Contenedor con mensaje de error o null si no hay error
 */
export default function ErrorMessage({ message }) {
  // No renderiza nada si no hay mensaje de error
  if (!message) return null;

  return (
    <div className="error-message" role="alert">
      <p>{message}</p>
    </div>
  );
}
